import { CareProviderSearchType, PointOfCareType } from "@/types/__generated__/union-types"

export const POINT_OF_CARE_VALUES: PointOfCareType[] = [
  "GENERAL_PRACTITIONER",
  "SPECIALIST",
  "HOSPITAL_ELECTIVE",
  "HOSPITAL_EMERGENCY_ROOM",
  "MEDICAL_EMERGENCY_OR_PERMANENCE",
]

export const getCareProviderSearchType = (
  pointOfCare: PointOfCareType | undefined,
  hasSpecialty: boolean,
): CareProviderSearchType => {
  switch (pointOfCare) {
    case "GENERAL_PRACTITIONER":
      return "GENERAL_PRACTITIONER"
    case "SPECIALIST":
      return hasSpecialty ? "SPECIALIST_WITH_SPECIALTY" : "SPECIALIST_WITHOUT_SPECIALTY"
    case "HOSPITAL_ELECTIVE":
      return hasSpecialty ? "HOSPITAL_ELECTIVE_WITH_SPECIALTY" : "HOSPITAL_ELECTIVE_WITHOUT_SPECIALTY"
    case "HOSPITAL_EMERGENCY_ROOM":
      return "HOSPITAL_EMERGENCY_ROOM"
    case "MEDICAL_EMERGENCY_OR_PERMANENCE":
      return "MEDICAL_EMERGENCY_OR_PERMANENCE"
    case "EMERGENCY_CALL":
    case "EXTERNAL_ASSISTANCE":
    case "INCOMPLETE_TELECONSULTATION":
    case "TELECARE":
    case undefined:
      return "TIME_WINDOW_WITH_REFERRAL_TO"
  }
}
